<template>
  <!-- 应收款统计 -->
  <div>
    <div class="home-pannel">
      <div class="home-pannel-title">
        <span>应收款统计</span>
        <div>
          <time-query @select="timeSelect"/>
        </div>
      </div>
      <div class="home-pannel-content">
        <a-row v-if="countPosition === 'top'" style="margin-top: 10px;">
          <a-row>
            <a-col v-for="(item,index) in jbkbList" :key="index">
              <a-col v-for="(el, ind) in item" :key="ind" :span="6" style="text-align:center;">
                <span v-if="el.slot" class="jineValue">
                  <span :style="el.color ? `color:${el.color}` : ''">{{setJine(jbkbDataObj[el.value])}}</span>
                </span>
                <span v-else class="jineValue">{{jbkbDataObj[el.value]}}</span>
              <br>
                <span :style="el.color ? `color:${el.color}` : ''">
                  {{el.name}}
                  <span v-if="el.slot">({{setUnit(jbkbDataObj[el.value])}})</span>
                </span>
              </a-col>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <myLineEcharts ref="receivableEchartsRef" echarts-id-val="receivableEcharts" line-title-name="应收金额统计" :echartsHeight="echartsHeight"/>
            </a-col>
          </a-row>
        </a-row>
        <a-row v-else-if="countPosition === 'right'">
          <a-col :span="16">
            <myLineEcharts ref="receivableEchartsRef" echarts-id-val="receivableEcharts" line-title-name="应收金额统计" :echartsHeight="echartsHeight"/>
          </a-col>
          <a-col :span="8" class="right-content">
            <a-row v-for="(item,index) in jbkbList" :key="index" type="flex" justify="space-around">
              <a-col v-for="(el, ind) in item" :key="ind" :span="10" style="margin-top: 70px;text-align:center;">
                <span v-if="el.slot" class="jineValue">
                  <span :style="el.color ? `color:${el.color}` : ''">{{setJine(jbkbDataObj[el.value])}}</span>
                </span>
                <span v-else class="jineValue">{{jbkbDataObj[el.value]}}</span>
              <br>
                <span :style="el.color ? `color:${el.color}` : ''">
                  {{el.name}}
                  <span v-if="el.slot">({{setUnit(jbkbDataObj[el.value])}})</span>
                </span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import myLineEcharts from './myLine.vue'
import timeQuery from './queryView.vue'
import { setJine, setUnit } from '@/utils/index.js'
export default {
  components: {myLineEcharts, timeQuery},
  props: {
    countPosition: {
      type: String,
      default: 'right'
    },
    echartsHeight: {
      type: String,
      default: '350px'
    }
  },
  data () {
    return {
      jbkbDataObj: {},
      jbkbList: [
        [
          {
            name: '应收单数(个)',
            value: 'count'
          },
          {
            name: '应收总金额',
            value: 'sum',
            slot: 'jine'
          }
        ],
        [
          {
            name: '30内到期额',
            value: 'thirtySum',
            slot: 'jine',
            color: '#faad14'
          },
          {
            name: '超期未回款',
            value: 'overSum',
            slot: 'jine',
            color: '#f5222d'
          }
        ]
      ]
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    setJine,
    setUnit,
    timeSelect (timeVal) {
      this.getData(timeVal)
    },
    getData (timeVal) {
      this.$get('/payBack/mobileBackPlanCount', {timeCondition: timeVal, backType: 0}).then(res => {
        if (res.data.status === 1) {
          this.jbkbDataObj = res.data.data
          this.$nextTick(() => {
            this.$refs.receivableEchartsRef.setData(this.jbkbDataObj.list)
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.right-content{
  margin-top: 20px;
}
  .jineValue{
    color:#4b9de1;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/receivableInfo.vue